var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient, computedFrom } from "aurelia-framework";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { LotteryBrandDiscountModel } from "../../../../../models/modules/lotteryplatofrm.models";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { LotteryClientService } from "../../../../../services/modules/lottery-client.service";
import * as Enumerable from "linq";
import { BindingSignaler } from "aurelia-templating-resources";
var BundleTicketDiscounts = /** @class */ (function (_super) {
    __extends(BundleTicketDiscounts, _super);
    function BundleTicketDiscounts(notificationService, i18N, lotteryClientService, bindingSignaler) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.bindingSignaler = bindingSignaler;
        return _this;
    }
    BundleTicketDiscounts.prototype.monthlySubscriptionChanged = function (event, item) {
        if (event.detail && event.detail.value) {
            this.updateNumberOfDraws();
        }
        else {
            setTimeout(function () {
                item.numberOfDraws = 1;
                item.subscriptionMonths = null;
            }, 200);
        }
    };
    Object.defineProperty(BundleTicketDiscounts.prototype, "pricingModels", {
        get: function () {
            return this.item && this.pricingModel && this.pricingModel.lotteryBrandDiscounts ? this.pricingModel.lotteryBrandDiscounts : [];
        },
        enumerable: false,
        configurable: true
    });
    BundleTicketDiscounts.prototype.monthValueChanged = function () {
        this.updateNumberOfDraws();
    };
    BundleTicketDiscounts.prototype.updateNumberOfDraws = function () {
        if (this.item && this.item.pricingModel && this.item.pricingModel.lotteryBrandDiscounts) {
            var lotteryBrandDiscounts = Enumerable.from(this.pricingModel.lotteryBrandDiscounts).where(function (x) { return x.isMonthlySubscription; }).toArray();
            if (lotteryBrandDiscounts) {
                var numberOfDrawsForAllLotteries_1 = Enumerable.from(this.item.bundleBrandLotteries).sum(function (x) { return Number(x.numberOfDraws); });
                lotteryBrandDiscounts.forEach(function (x) {
                    setTimeout(function () {
                        x.numberOfDraws = numberOfDrawsForAllLotteries_1 * x.subscriptionMonths;
                    });
                });
                this.bindingSignaler.signal("updateNumberOfDraws");
            }
        }
    };
    BundleTicketDiscounts.prototype.addDiscount = function () {
        var model = new LotteryBrandDiscountModel();
        model.chanceOfWinning = 0;
        model.numberOfDraws = 1;
        model.discount = 0;
        model.countryId = null;
        model.subscriptionMonths = null;
        model.promotionalTitle = "";
        model.isMonthlySubscription = false;
        model.isBestValue = false;
        model.isDefault = false;
        this.pricingModel.lotteryBrandDiscounts.push(model);
    };
    BundleTicketDiscounts.prototype.onActivated = function (item) {
        this.pricingModel = item.pricingModels[0];
    };
    BundleTicketDiscounts.prototype.removeDiscount = function (item) {
        var index = this.pricingModel.lotteryBrandDiscounts.indexOf(item);
        this.pricingModel.lotteryBrandDiscounts.splice(index, 1);
    };
    Object.defineProperty(BundleTicketDiscounts.prototype, "isReadonly", {
        get: function () {
            if (!this.pricingModel || !this.item || !this.item.navigationInfo)
                return true;
            return this.item.navigationInfo.brandId && this.item.navigationInfo.brandId != this.pricingModel.brandId;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        computedFrom("pricingModel.lotteryBrandDiscounts", "pricingModel"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BundleTicketDiscounts.prototype, "pricingModels", null);
    __decorate([
        computedFrom("pricingModel", "item", "item.navigationInfo"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BundleTicketDiscounts.prototype, "isReadonly", null);
    BundleTicketDiscounts = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, LotteryClientService, BindingSignaler])
    ], BundleTicketDiscounts);
    return BundleTicketDiscounts;
}(ChildComponent));
export { BundleTicketDiscounts };
